"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoanSharkAbilityHandler = exports.LoanSharkActorAbilityFactory = exports.LoanSharkAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const LoanShark_1 = require("../../core/effects/core/LoanShark");
const Duration_1 = require("../../core/Duration");
const LoanedStats_1 = require("../../core/effects/core/LoanedStats");
const EventType_1 = require("../../core/events/EventType");
const Schedule_1 = require("../../core/Schedule");
const core_1 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
const enums_1 = require("../../core/enums");
const core_2 = require("../../core/event-handlers/core");
class LoanSharkAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.LoanShark;
        this.__typeName = "LoanShark";
    }
}
exports.LoanSharkAbilityArgs = LoanSharkAbilityArgs;
let LoanSharkActorAbilityFactory = class LoanSharkActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("LoanShark", "OneAllies", 4);
    }
};
LoanSharkActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("LoanShark")
], LoanSharkActorAbilityFactory);
exports.LoanSharkActorAbilityFactory = LoanSharkActorAbilityFactory;
let LoanSharkAbilityHandler = class LoanSharkAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [selectedAlly] = ability.args.target.actorIds;
        const attributes = [
            enums_1.AttributeType.Power,
            enums_1.AttributeType.Focus,
            enums_1.AttributeType.Will,
            enums_1.AttributeType.Toughness
        ].map(attribute => ({
            score: container.getPercentOfBaseAttributeScore(ability.invokerId, 30, attribute),
            attribute
        }));
        container.applyAbilityAnimation({
            sequence,
            abilityKey: ability.args.__typeName,
            fallback: "casting",
            animatedId: ability.invokerId,
            onAnimated(sequence) {
                container.applyDebuff({
                    sequence: sequence.pushSequence("sequential"),
                    attackerId: ability.invokerId,
                    targetId: ability.invokerId,
                    duration: Duration_1.Duration.Turns(3),
                    effect: new LoanShark_1.LoanSharkEffectArgs(attributes),
                    onApplied(sequence) {
                        sequence.push(new core_1.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(selectedAlly, "feet", "behind"), "DarkMagicCircle"));
                    },
                    supernatural: true
                });
                container.applyBuff({
                    creatorId: ability.invokerId,
                    targetId: selectedAlly,
                    duration: container.testAttribute(ability.invokerId, "Luck", 2) ? Duration_1.Duration.Permanent
                        : Duration_1.Duration.Turns(3),
                    effect: new LoanedStats_1.LoanedStatsEffectArgs(attributes),
                    sequence: sequence.pushSequence("sequential"),
                    onApplied(sequence) {
                        sequence.push(new core_1.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(selectedAlly, "feet", "behind"), "BlueMagicCircle"));
                    },
                    supernatural: true,
                });
                container.registerEventHandler(selectedAlly, EventType_1.EventType.TurnStarted, Schedule_1.Schedule.Combined(3, 1), new core_2.ApplyEffectEventHandlerArgs(selectedAlly, Target_1.Target.Self, Duration_1.Duration.Turns(3), new LoanShark_1.LoanSharkEffectArgs(attributes), true));
                container.registerEventHandler(ability.invokerId, EventType_1.EventType.TurnStarted, Schedule_1.Schedule.Combined(3, 1), new core_2.ApplyEffectEventHandlerArgs(ability.invokerId, Target_1.Target.Self, Duration_1.Duration.Turns(3), new LoanedStats_1.LoanedStatsEffectArgs(attributes), true));
            }
        });
    }
};
LoanSharkAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.LoanShark)
], LoanSharkAbilityHandler);
exports.LoanSharkAbilityHandler = LoanSharkAbilityHandler;
